import { Fragment, useEffect, useState, useContext } from "react"
import { Context } from '../../components/Store'
import { useQuery } from '@apollo/client'
import { COMPANY_QUERY } from '../../apollo/query'
// import { siglaRoB64 } from "../../assets/siglaRoB64"
import moment from 'moment'
import { Grid, Typography, makeStyles, Table, TableHead, TableBody, TableRow, TableCell, createMuiTheme } from '@material-ui/core'
import { rowTotal } from '../../lib/compute'

const useStyles = makeStyles(theme => ({
    root: { flexGrow: 1 },
    table: {
        tableLayout: "auto",
        width: "100%",
        '&& thead>tr>th, tfoot>tr>td': {
            border: "1px solid grey",
            background: theme.palette.grey[200],
            wordWrap: "normal",
            fontSize: "0.7rem", lineHeight: 1, padding: theme.spacing(1)
        },
        '&& tbody>tr>td, tfoot>tr>td': {
            border: "1px solid grey",
            fontSize: "0.7rem",
        },
        '&& tbody>tr>td': {
            wordWrap: "break-word",
            padding: theme.spacing(0.5)
        },
    }

}))


const ProgramAnualTemplate = props => {
    const classes = useStyles()
    const [antet, setAntet] = useState()
    const [program, setProgram] = useState()
    const [state, __] = useContext(Context)
    const { data, loading, error } = useQuery(COMPANY_QUERY, {
        variables: {
            id: program && program.company_id
        }
    })

    useEffect(() => {
        if (props.data) setProgram({...props.data, referate: [...props.data.referate]})
    }, [props.data])

    useEffect(() => {
        console.log("populating antet...", data && data.company)
        if (data && data.company) { setAntet(data.company) }
        
    }, [data])

    const ref2products = referate => [...referate].reduce((acc, item) => {
        return [...acc, ...item.products]
    }, [])

    return (
        <Fragment>
            {program && antet && (
                <Fragment>
                    <Grid container justify="space-between" alignItems="flex-start">
                        {/* <Grid item xs={1}>
                            <img src={siglaRoB64} style={{ height: "80px", widTableCell: "auto" }} />
                        </Grid> */}
                        <Grid item xs={12}>
                            {antet.name}
                        </Grid>
                        <Grid item xs={12} align="center">
                            <Typography variant="h5">
                                {program.name}
                            </Typography>
                            <Typography variant="body2">
                                nr. {program.nrdoc} din {moment(program.dTableCelloc).format('DD.MM.YYYY')}
                            </Typography>
                        </Grid>
                        <Grid item xs = {8}></Grid>
                        <Grid item xs = {4} align  = "center">
                        Aprob<br/><br/>
Conducatorul autoritatii contractante,<br/><br/>
. . . . . . . . . . . . . . . . .<br/><br/>

                        {/* <pre>{JSON.stringify(ref2products(program.referate, null,4))}</pre> */}
                        </Grid>

                    </Grid>
                    <Table className={classes.table} cellSpacing={0}>
                        <TableHead>
                            <TableRow>
                                <TableCell width  = "5%" align ="center">Nr.crt</TableCell>
                                <TableCell width  = "40%" align ="center">Tipul si obiectul<br/>contractului de achizitie publica/<br/>acordului- cadru</TableCell>
                                <TableCell width = "10%" align ="center">Cod CPV</TableCell>
                                <TableCell width  = "15%" align ="center">Valoarea estimata a contractului de achizitie publica/ <br/>acordului-cadru <br/><br/> (LEI, fără TVA)</TableCell>
                                <TableCell width  = "15%" align ="center">Sursa de finanțare</TableCell>
                                <TableCell width  = "15%" align ="center">Procedura stabilita/<br/>instrumente specifice<br/>pentru derularea<br/>procesului de achizitie</TableCell>
                                <TableCell width = "10%" align ="center">Data (luna) estimata pentru initierea procedurii</TableCell>
                                <TableCell width = "10%" align ="center">Data (luna) estimata pentru atribuirea contractului de achizitie publica/<br/>acordului-cadru</TableCell>
                                <TableCell width = "10%" align ="center">Modalitatea de derulare <br/>a procedurii <br/>de atribuire <br/><br/>online/offline</TableCell>
                                <TableCell width = "10%" align ="center">Persoana responsabila cu aplicarea procedurii de atribuire</TableCell>

                            </TableRow>
                        </TableHead>
                        {/* {ref2products(program.referate).length} */}
                        <TableBody>
                            {console.log("refs:", program && program.referate)}
                            {ref2products(program.referate).map((e, i) => {
                                console.log("i:", e)
                                return (

                                <TableRow key={i}>
                                    <TableCell  align ="center">{i + 1}</TableCell>
                                    <TableCell>{e.name}</TableCell>
                                    <TableCell align ="center">{e.cpv ? e.cpv.code : "---"}</TableCell>
                                    <TableCell align ="right">{rowTotal(e, false).toFixed(2)}</TableCell>
                                    <TableCell align ="center">{e.sursa && e.sursa.name}</TableCell>
                                    <TableCell align ="center">{e.procedura && e.procedura.name}</TableCell>
                                    <TableCell align ="center">{e.start ? moment(e.start).format('DD.MM.YYYY') : "- - - "}</TableCell>
                                    <TableCell align ="center">{e.end ? moment(e.end).format('DD.MM.YYYY') : "- - - "}</TableCell>
                                    <TableCell align ="center">
                                        {
                                            e.procedura && e.procedura.name 
                                            && (e.procedura.name.includes("ONLINE") && !e.procedura.name.includes("OFFLINE"))
                                                ? "ONLINE": null
                                        }
                                                                                {
                                            e.procedura && e.procedura.name && e.procedura.name.includes("OFFLINE")
                                                ? "OFFLINE": null
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {state.name} {state.surname}
                                    </TableCell>
                                </TableRow>

                            )})}
                        </TableBody>
                    </Table>
                    <div align = "center">
                    <br/><br/><br/>
                    Elaborat<br/>
Compartiment intern specializat in domeniul achizitiilor publice/<br/>Persoana desemnata<br/><br/>
{state.name} {state.surname}<br/><br/> . . . . . . . . . . . . . . . . . .
                    </div>
                </Fragment>
            )}
        </Fragment>

    )
}

export default ProgramAnualTemplate